// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1NyGk","range":"MonthRangeSwitch_range__1Ry6b","disabled":"MonthRangeSwitch_disabled__JZD6m"};